import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../../assets/css/Portfolio.module.css";

export interface PortfolioItemData {
  image?: string;
  title?: string;
  description?: string;
  tags?: string;
  links?: Array<string>;
  limit?: number;
  isFullWidth?: boolean;
}

export let NeonRace: PortfolioItemData = {
  image: "/img/portfolio/NeonRace.png",
  title: "Neon Race",
  description: "NeonRace_Description",
  links: [
    "https://play.google.com/store/apps/details?id=com.WaitWhatInteractive.NeonRace",
  ],
  tags: "Race, 2D, Neon, HandDraw, Endless, TopDown",
};

const portfolio: Array<PortfolioItemData> = [
  // NeonRace,
  {
    title: "Becoming Knight",
    image: "/img/portfolio/BecomingKnight.png",
    description: "BecomingKnight_Description",
    links: ["https://store.steampowered.com/app/4442720/Becoming_Knight/"],
    tags: "2D, Turn-Based, Dungeon, Role, Strategy, RPG",
  },
  {
    title: "Critter Code",
    description: "CritterCode_Description",
    links: [
      "https://play.google.com/store/apps/details?id=com.pointypine.crittercode",
      "https://apps.apple.com/ua/app/critter-code/id6746582689",
    ],
    tags: "3D, Turn-Based, Tactic, Collection, Scanner, Battler",
  },
  {
    image: "/img/portfolio/eternal-rush.png",
    title: "Run of Valor",
    description: "RunOfValor_Description",
    links: ["https://octowyth.itch.io/run-of-valor"],
    tags: "2D, Pixel-Art, Runner, Role Play, Idle",
  },
  {
    image: "/img/portfolio/Mafia.png",
    title: "Mafia Defense",
    description: "MafiaDefense_description",
    links: [
      "https://play.google.com/store/apps/details?id=org.octo.mafia.tower.defense",
    ],
    tags: "2D, Simulator, Survival, Defense",
  },
  {
    image: "/img/portfolio/radiant_defender.png",
    title: "Radiant Defender",
    description: "RadiantDefender_description",
    links: ["https://radiant-arcade.com/play/radiant-defender"],
    tags: "2D, Role Play, BulletHell, Pixel-Art, Web3, Survival",
  },
  {
    image: "/img/portfolio/LKA.png",
    title: "Little Knight Adventure",
    description: "LittleKnightAdventure",
    links: ["https://play.google.com/store/apps/details?id=org.knight.run"],
    tags: "2D, Role Play, Runner, Idle",
  },
  {
    image: "/img/portfolio/DeLibertate.png",
    title: "De Libertate",
    description: "DeLibertate_description",
    links: [
      "https://play.google.com/store/apps/details?id=com.rexevropae.DeLibertateUkraine19171922",
    ],
    tags: "2D, Strategy, Turn-Based, Pixel-Art",
  },
  {
    image: "/img/portfolio/AnilaughStudio.png",
    title: "Anilaugh Studio",
    description: "AnilaughStudio_Description",
    links: ["https://endl11.itch.io/anilaugh-studio"],
    tags: "2D, Tycoon, Management, Point & Click",
  },
  {
    image: "/img/portfolio/SWTR.png",
    title: "Smart Ways To Root",
    description: "SWTR_description",
    links: ["https://madisan.itch.io/smart-ways-to-root"],
    tags: "2D, Casual, Point & Click, Puzzle",
  },
  {
    image: "/img/portfolio/IntoTheRoots.png",
    title: "Into The Roots",
    description: "IntoTheRoots_description",
    links: ["https://paveleon.itch.io/into-the-roots"],
    tags: "2D, Casual, Arcade, Puzzle",
  },
  {
    image: "/img/portfolio/color_wars.png",
    title: "Color Wars. Towers!",
    description: "ColorWars_description",
    links: ["https://wait-what-interactive.itch.io/color-wars-towers"],
    tags: "2D, Puzzle, Tower Defense, Paper, Realistic",
  },
  {
    image: "/img/portfolio/hunters_rite.png",
    title: "Hunters Rite",
    description: "HuntersRite_description",
    links: ["https://fugas-education.itch.io/hunters-rite"],
    tags: "2D, Pixel-Art, Role Play, Local Coop, RogueLike",
    limit: 370,
    isFullWidth: true,
  },
];

let slicedPortfolio: PortfolioItemData[][] = [];
let tempArray: PortfolioItemData[] = [];

portfolio.forEach((item, index) => {
  if (item.isFullWidth) slicedPortfolio.push(Array<PortfolioItemData>(item));

  tempArray.push(item);

  if (tempArray.length == 2) {
    slicedPortfolio.push(tempArray);
    tempArray = [];
  }
});

export const PortfolioItem = ({
  image,
  title = "TBA",
  description = "TBA",
  links = [],
  tags = "TBA",
  limit = 155,
}: PortfolioItemData) => {
  const { t } = useTranslation();

  image ??= "/img/empty_project.png";
  const localizedDescription = t(description);

  const IsGoogle = (url: string) => url?.includes("play.google") ?? false;
  const IsApple = (url: string) => url?.includes("apple") ?? false;
  const IsItch = (url: string) => url?.includes("itch") ?? false;
  const IsSteam = (url: string) => url?.includes("steampowered") ?? false;

  const CustomBadge = ({ url }: any) => (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={styles.customBadge}
    >
      {t("Play")}
    </a>
  );

  return (
    <div className={styles.item}>
      <img
        className={styles.image}
        src={window.location.origin + image}
        alt={`${title}_game`}
      />
      <div className={styles.itemText}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>
          {localizedDescription.slice(0, limit)}
          {localizedDescription.length > limit ? ".." : ""}
        </p>
        {tags && (
          <div className={styles.tagsWrap}>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="matrix(1 0 0 -1 15 7.00024)"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.77423 10.1439C0.771085 11.2643 0.749503 12.9546 1.67016 14.1437C3.49711 16.5033 5.49674 18.5029 7.85633 20.3298C9.0454 21.2505 10.7357 21.2289 11.8561 20.2258C14.8979 17.5022 17.6835 14.6559 20.3719 11.5279C20.6377 11.2187 20.8039 10.8397 20.8412 10.4336C21.0062 8.63798 21.3452 3.46467 19.9403 2.05974C18.5353 0.654811 13.362 0.993766 11.5664 1.15876C11.1603 1.19608 10.7813 1.36233 10.472 1.62811C7.34412 4.31646 4.49781 7.10211 1.77423 10.1439Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M6 13.0002L9 16.0002"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <b>{tags}</b>
          </div>
        )}
        <div className={styles.badges}>
          {links.map((link, i) => (
            <React.Fragment key={i}>
              {!IsGoogle(link) &&
                !IsApple(link) &&
                !IsItch(link) &&
                !IsSteam(link) &&
                links.length > 0 && <CustomBadge url={link} />}
              {(IsGoogle(link) ||
                IsApple(link) ||
                IsItch(link) ||
                IsSteam(link)) && (
                <a href={link} target="_blank" rel="noreferrer">
                  {IsGoogle(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin +
                        "/img/badges/google_play_badge.svg"
                      }
                      alt="google"
                    />
                  )}
                  {IsApple(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin +
                        "/img/badges/app_store_badge.svg"
                      }
                      alt="apple"
                    />
                  )}
                  {IsItch(link) && (
                    <img
                      className={styles.badge}
                      src={window.location.origin + "/img/badges/itch.svg"}
                      alt="itch"
                    />
                  )}
                  {IsSteam(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin + "/img/badges/steam_badge.png"
                      }
                      alt="steam"
                    />
                  )}
                </a>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Portfolio = () => {
  const prePortfolioAmount = 6;
  const { t } = useTranslation();
  const [showAll, setShowAll] = React.useState<boolean>(false);

  let counter = 0;

  const handleClick = () => {
    setShowAll((prev: boolean) => !prev);
  };

  return (
    <div className={styles.wrapper}>
      <>
        {slicedPortfolio.map((slice, index) => {
          if (counter == prePortfolioAmount && !showAll) return;
          return (
            <div className={styles.itemsRow} key={index}>
              {slice.map((item, i) => {
                if (counter == prePortfolioAmount && !showAll) return;

                counter += 1;
                return <PortfolioItem key={i} {...item} />;
              })}
            </div>
          );
        })}
      </>
      <button className={styles.mainButton} onClick={handleClick}>
        {!showAll ? t("All Games") : t("Less")}
      </button>
    </div>
  );
};
